import Service from "../Service";

const resource = "Agricultural/";

export default {
  save(cmp, requestID) {
    return Service.post(resource + "save", cmp, {
      params: { requestID: requestID },
    });
  },

  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },
  listFarm(CodSenasa, requestID) {
    return Service.post(resource + "listFarm", CodSenasa, {
      params: { Senasa: CodSenasa, requestID: requestID },
    });
  },
  listFarmByFltIDs(FltIDs, requestID) {
    return Service.post(resource + "listFarmByFltIDs", FltIDs, {
      params: { FltIDs, requestID },
    });
  },
  getFarmGeometryGeoJSON(FagID, requestID) {
    return Service.get(resource + `geojsonById/${FagID}`, {
      params: { requestID: requestID },
    });
  },
  getHierarchy(requestID) {
    return Service.get(resource + "hierarchy", { params: { requestID } });
  },
  getListMin(requestID) {
    return Service.get(resource + "list-min", { params: { requestID } });
  },
  getListAll(requestID, search) {
    const params = { requestID };
    if (search) params.search = search;
    return Service.get(resource + "list-all", { params });
  },
  refreshCacheFarmPoint(farm, requestID) {
    // Normaliza al esquema exigido por la API y convierte DMS -> decimal
    const toDecimal = (v) => {
      if (v == null) return undefined;
      if (typeof v === "number") return v;
      const s = String(v).trim();
      if (!s.includes("°")) return parseFloat(s);
      const re = /([\d.]+)°\s*([\d.]+)?'?\s*([\d.]+)?"?\s*([NSEWnsew-])?/;
      const m1 = s.match(re);
      if (!m1) return parseFloat(s);
      const deg = parseFloat(m1[1] || 0),
        min = parseFloat(m1[2] || 0),
        sec = parseFloat(m1[3] || 0);
      let sign = 1;
      if (/S|s|W|w|-/.test(s)) sign = -1;
      return sign * (deg + min / 60 + sec / 3600);
    };
    const payload = {
      fagId: farm.FagID || farm.fagId,
      lat: farm.lat ?? toDecimal(farm.FagLatitude),
      lon: farm.lon ?? toDecimal(farm.FagLength),
    };
    return Service.post(resource + "point", payload, {
      params: { requestID: requestID },
    });
  },
  refreshCacheFarmGeometry(FagID, geometry, requestID) {
    return Service.post(
      resource + "geometryWkt",
      { fagId: FagID, geometry: geometry },
      {
        params: { requestID: requestID },
      }
    );
  },
  getNearbyFarmsGeoJSON(lat, lon, radiusMeters = 10, requestID) {
    return Service.get(resource + "nearby", {
      params: { lat, lon, radius: radiusMeters, requestID },
    });
  },
};
